import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// Components
import DiscountBanner from './components/DiscountBanner';
import CookieConsentBanner from './components/CookieConsentBanner';

// Pages
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import SigninPage from './pages/SigninPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CreateAvatarPage from './pages/CreateAvatarPage';
import AvatarChatPage from './pages/AvatarChatPage';
import ProjectChatPage from './pages/ProjectChatPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import AddonPaymentSuccessPage from './pages/AddonPaymentSuccessPage';
import PlanSelectionPage from './pages/PlanSelectionPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import BetaSignupPage from './pages/BetaSignupPage';
import BetaExpiredPage from './pages/BetaExpiredPage';
import RelationCaptureScreen from './pages/RelationCaptureScreen';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect invite links to signup EXCEPT when the link intentionally targets /signin.
  // - New users should land on /signup
  // - Existing users can land on /signin (email invite logic decides which one to send)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const inviteId = params.get('invite_id');
    const inviteEmail = params.get('invite_email');
    const isSignup = location.pathname === '/signup';
    const isSignin = location.pathname === '/signin';
    const isCreateAvatar = location.pathname === '/create-avatar';
    if ((inviteId || inviteEmail) && !isSignup && !isSignin && !isCreateAvatar) {
      const newParams = new URLSearchParams();
      if (inviteId) newParams.set('invite_id', inviteId);
      if (inviteEmail) newParams.set('invite_email', inviteEmail);
      navigate(`/signup?${newParams.toString()}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return (
    <div className="app">
      <DiscountBanner />
      <CookieConsentBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signin" element={<SigninPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/create-avatar" element={<CreateAvatarPage />} />
        <Route path="/chat" element={<AvatarChatPage />} />
        <Route path="/select-plan" element={<PlanSelectionPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/addon/success" element={<AddonPaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PlanSelectionPage />} />
        <Route path="/projects" element={<ProjectChatPage />} />
        <Route path="/legal" element={<PrivacyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/beta" element={<BetaSignupPage />} />
        <Route path="/beta-expired" element={<BetaExpiredPage />} />
        <Route path="/relation-capture" element={<RelationCaptureScreen />} />
        {/* Catch-all route - redirect to home if route not found */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </div>
  );
}

export default App;
